import { render } from "./VatToggle.vue?vue&type=template&id=637bb936&scoped=true"
import script from "./VatToggle.vue?vue&type=script&lang=js"
export * from "./VatToggle.vue?vue&type=script&lang=js"

import "./VatToggle.vue?vue&type=style&index=0&id=637bb936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637bb936"]])

export default __exports__